import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { toast } from 'react-toastify';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { SimpleTable } from '~/components';
import { Input, Autocomplete, DateTime } from '~/components/Form';
import { Button } from '@material-ui/core';
import { Print } from '@material-ui/icons';
import { t, number } from '~/helpers';
import api from '~/services/api';
import { ContainerForm } from './styles';

//import { ADM, GFO, GPP, FRENTISTA, CONSULTA_OPERACAO } from '~/constants/perfil';

export default function MyForm({ data, reference, close }) {

  const [tableData, setTableData] = useState([]);
  const [tankData, setTankData] = useState([]);
  const [tankCodes, setTankCodes] = useState('');
  const [totalNfVolume, setTotalNfVolume] = useState(0);
  const [totalValorTotal, setTotalValorTotal] = useState(0);
  const [product, setProduct] = useState('');

  //const { profile } = useSelector((state) => state.user);

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        rgpIntegracaoSiad: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        codPosto: data.poco_codigo,
        status: param.rgpIntegracaoSiad,
      };

      await api.put('postocontrolesiad', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  useEffect(() => {
    if (tableData.length > 0) {
      const volumes = tableData.map((item) => item.prri_volume_nf);
      const total = tableData.reduce((sum, item) => sum + parseFloat(item.prri_volume_nf || 0), 0);
      const valorTotal = tableData.reduce((sum, item) => sum + parseFloat(item.desc_valor_total_tela || 0), 0);
      const prod = tableData[0]?.prod_display || '';
      setTotalNfVolume(total);
      setTotalValorTotal(valorTotal);
      setProduct(prod);
      console.log('Dados da SimpleTable (recebimento provisório):', tableData);
      console.log('Volumes extraídos:', volumes);
      console.log('Volume total NFs:', total);
      console.log('Valor Total(R$):', valorTotal);
      console.log('Produto:', prod);
    }

    if (tankData.length > 0) {
      const tankVolumes = tankData.map((item) => item.prta_volume_medido);
      const codes = tankData.map((item) => item.tafi_codigo).join(', ');
      setTankCodes(codes);
      console.log('Dados da SimpleTable (tanques receptores):', tankData);
      console.log('Volumes medidos:', tankVolumes);
      console.log('Códigos dos tanques:', codes);
    }
  }, [tableData, tankData]);

  function handlePrint() {
    window.print();
  }

  return (
    <>
      <ContainerForm
        className="print-area"
        ref={reference}
        initialData={{
          ...data,
          recebedor_responsavel: `${data.usua_cpf_recebedor_responsavel}/${data.usua_nome_recebedor_responsavel}`,
        }}
        onSubmit={handleSubmit}
      >
        <Button
          className="print-button"
          startIcon={<Print />}
          variant="outlined"
          color="primary"
          type="button"
          onClick={handlePrint}
          style={{ marginBottom: '1rem' }}
        >
          Imprimir
        </Button>

        {/* {JSON.stringify(data)} */}

        <div className="print">
          <p>Sistema de Gestão Total dos Abastecimentos – SGTA</p>
        </div>


        <div className='section-title'>
          <p>RESUMO DO RECEBIMENTO PROVISÓRIO</p>
        </div>

        <Input
          name="prre_cosi_contratogta"
          label="Contrato nº"
          placeholder=""
          disabled
        />

        <Input
          name="prre_num_ano_empenho"
          label="Nº/Ano do Empenho"
          placeholder=""
          disabled
        />

        <Input
          name="recebedor_responsavel"
          label="Recebedor Responsável"
          placeholder=""
          disabled
        />

        <DateTime
          time
          name="prre_data_cadastro"
          label="Data de Cadastro"
          disabled
          invalidDateMessage={''}
        />

        <Input
          name="tanques_destino"
          label="Nº do(s) Tanque(s) destino:"
          placeholder=""
          value={tankCodes}
          disabled
        />

        <Input
          name="volume_total_nfs"
          label="Volume total NF's:"
          placeholder=""
          value={number(totalNfVolume, 1)}
          disabled
        />

        <Input
          name="valor_total_r"
          label="Valor Total(R$):"
          placeholder=""
          value={number(totalValorTotal, 2)}
          disabled
        />

        <Input
          name="produto"
          label="Produto:"
          placeholder=""
          value={product}
          disabled
        />

        <div className="no-print">
          <p>Dados do Recebimento Provisório</p>
        </div>

        <SimpleTable
          onDataChange={setTableData}
          url="operacaoprerecebimentolistas"
          cells={[
            {
              id: 'prre_codigo',
              label: 'Recebimento Provisório',
            },
            {
              id: 'prri_nf',
              label: 'Nota Fiscal:',
            },
            {
              id: 'prod_display',
              label: 'Produto:',
            },
            {
              id: 'prri_volume_nf',
              label: 'Volume(L):',
              align: 'right',
              format: (value) => number(value, 1),
            },
            {
              id: 'desc_valor_total_tela',
              label: 'Valor Total(R$):',
              align: 'right',
              format: (value) => number(value, 2),
            },
            {
              id: 'orga_nome',
              label: 'Órgão:',
            },

          ]}

          unique={['prri_nf']}
          form={MyForm}
          onCreate={false}
          onUpdate={false}
          onDelete={false}
          title={'Recebimento Provisório'}
          restProps={''}
          query={{
            wherefield: ['prre_codigo'],
            valuewherefield: [data.prre_codigo],
            typewherefield: ['EQUALS'],
          }}
        // totals={[
        //   {
        //     id: 'prri_volume_nf',
        //     label: 'Volume:',
        //     align: 'right',
        //     format: (value) => number(value, 1),
        //   }
        // ]}
        />

        <div className="no-print">
          <p>Tanques Receptores</p>
          <SimpleTable

            url="operacaoprerecebimentotanquesreceptoreslistas"
            cells={[
              {
                id: 'tafi_codigo',
                label: 'Tanque:',
              },
              {
                id: 'prta_volume_inicial',
                label: 'Vol.Inicial:',
                align: 'right',
                format: (value) => number(value, 1),
              },
              {
                id: 'prta_volume_final',
                label: 'Vol.Final:',
                align: 'right',
                format: (value) => number(value, 1),
              },
              {
                id: 'prta_modoleitura_ini_str',
                label: 'Modo Leitura Inicial:',
              },
              {
                id: 'prta_modoleitura_fim_str',
                label: 'Modo Leitura Final:',
              },
              {
                id: 'prta_volume_medido',
                label: 'Vol.Medido:',
                align: 'right',
                format: (value) => number(value, 1),
              },
              {
                id: 'tafi_capacidade',
                label: 'Capacidade Tanque:',
                align: 'right',
                format: (value) => number(value, 1),
              },


            ]}

            unique={['tafi_codigo']}
            form={MyForm}
            onCreate={false}
            onUpdate={false}
            onDelete={false}
            title={'Tanques Receptores'}
            restProps={''}
            query={{
              wherefield: ['prre_codigo'],
              valuewherefield: [data.prre_codigo],
              typewherefield: ['EQUALS'],
            }}
            // totals={[
            //   {
            //     id: 'prta_volume_medido',
            //     label: 'Vol.Medido:',
            //     align: 'right',
            //     format: (value) => number(value, 1),
            //   },
            // ]}
            onDataChange={setTankData} />
        </div>

      </ContainerForm>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
